// extracted by mini-css-extract-plugin
export default {"fullscreen":"Loader_fullscreen__W9ehc","local":"Loader_local__6FRAF"};